export const sessionMap = {
  /** 用于标记是否已经通过推荐链接自动登录 */
  REFERRAL_AUTO_LOGIN: "REFERRAL_AUTO_LOGIN",
  /** 用于标记登录引导弹窗是否已被关闭 */
  LOGIN_GUIDE_DISMISSED: "LOGIN_GUIDE_DISMISSED",
} as const;
